import React from 'react';
import { FormField, FormFieldLabel, FormFieldTextArea } from 'styles/common.styles';

/**
 * TextArea ?�???�드 컴포?�트
 * 
 * @param {Object} props
 * @param {string} props.name - ?�드 ?�름
 * @param {string} props.label - ?�드 ?�벨
 * @param {string} props.value - ?�드 �? * @param {string} props.width - ?�드 ?�비
 * @param {string} props.flex - flex ?�성
 * @param {string} props.labelWidth - ?�벨 ?�비
 * @param {string} props.fieldWidth - FormField ?�체 ?�비
 * @param {boolean} props.readonly - ?�기 ?�용 ?��?
 * @param {number} props.rows - textarea ????(기본�? 4)
 * @param {Function} props.onChange - �?변�??�들?? * @param {Object} props.fieldProps - 추�? ?�드 ?�성
 */
const TextAreaField = ({
  name,
  label,
  value = '',
  width,
  flex,
  labelWidth,
  fieldWidth,
  showColon = false,
  readonly = false,
  rows = 4,
  onChange,
  fieldProps = {},
}) => {
  return (
    <FormField
      flex={flex || '0 0 auto'}
      width={fieldWidth || 'auto'}
    >
      {label && (
        <FormFieldLabel width={labelWidth} >{showColon ? `${label}:` : label}</FormFieldLabel>
      )}
      <FormFieldTextArea
        name={name}
        value={value}
        readOnly={readonly}
        onChange={readonly ? undefined : onChange}
        width={width || 'auto'}
        rows={rows}
        {...fieldProps}
      />
    </FormField>
  );
};

export default TextAreaField;

